import { IncidentCategoryOption } from "@/graphql/generated"
import { SmallInfoCard } from "./SmallInfoCard"
import { useUserLanguage } from "@/customHooks"

import cleaningIcon from '@/assets/incidents-icons/cleaning-icon.svg'
import constructionIcon from '@/assets/incidents-icons/construction-icon.svg'
import electricityIcon from '@/assets/incidents-icons/electricity-icon.svg'
import gardeningIcon from '@/assets/incidents-icons/gardering-icon.svg'
import gasIcon from '@/assets/incidents-icons/gas-icon.svg'
import internetIcon from '@/assets/incidents-icons/internet-icon.svg'
import metalCarpentryIcon from '@/assets/incidents-icons/metal-carpentry-icon.svg'
import otherIcon from '@/assets/incidents-icons/other-icon.svg'
import waterIcon from '@/assets/incidents-icons/water-icon.svg'
import woodCarpentryIcon from '@/assets/incidents-icons/wood-carpentry-icon.svg'
import lockIcon from '@/assets/incidents-icons/lock-icon.svg'

type IncidentCategoryMapperWithIconProps = {
  categoryOption: IncidentCategoryOption
}

const textsData = {
  en: {
    cleaningCard: {
      value: 'Cleaning',
      title: 'Category',
    },
    constructionCard: {
      value: 'Construction',
      title: 'Category',
    },
    electricityCard: {
      value: 'Electricity',
      title: 'Category',
    },
    gardeningCard: {
      value: 'Gardening',
      title: 'Category',
    },
    gasCard: {
      value: 'Gas',
      title: 'Category',
    },
    internetCard: {
      value: 'Internet',
      title: 'Category',
    },
    metalCarpentryCard: {
      value: 'Metal Carpentry',
      title: 'Category',
    },
    otherCard: {
      value: 'Other',
      title: 'Category',
    },
    waterCard: {
      value: 'Water',
      title: 'Category',
    },
    woodCarpentryCard: {
      value: 'Wood Carpentry',
      title: 'Category',
    },
    lockCard: {
      value: 'Lock',
      title: 'Category',
    },
  },
  es: {
    cleaningCard: {
      value: 'Limpieza',
      title: 'Categoría'
    },
    constructionCard: {
      value: 'Construcción',
      title: 'Categoría'
    },
    electricityCard: {
      value: 'Electricidad',
      title: 'Categoría'
    },
    gardeningCard: {
      value: 'Jardinería',
      title: 'Categoría'
    },
    gasCard: {
      value: 'Gas',
      title: 'Categoría'
    },
    internetCard: {
      value: 'Internet',
      title: 'Categoría'
    },
    metalCarpentryCard: {
      value: 'Carpintería Metálica',
      title: 'Categoría'
    },
    otherCard: {
      value: 'Otro',
      title: 'Categoría'
    },
    waterCard: {
      value: 'Agua',
      title: 'Categoría'
    },
    woodCarpentryCard: {
      value: 'Carpintería de Madera',
      title: 'Categoría'
    },
    lockCard: {
      value: 'Cerrajería',
      title: 'Category',
    },
  }
}

export const IncidentCategoryMapperWithIcon = ({ categoryOption }: IncidentCategoryMapperWithIconProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  switch (categoryOption) {
    case IncidentCategoryOption.Cleaning: return (
      <SmallInfoCard
        icon={cleaningIcon}
        title={texts.cleaningCard.title}
        value={texts.cleaningCard.value}
      />
    )
    case IncidentCategoryOption.Construction: return (
      <SmallInfoCard
        icon={constructionIcon}
        title={texts.constructionCard.title}
        value={texts.constructionCard.value}
      />
    )
    case IncidentCategoryOption.Electricity: return (
      <SmallInfoCard
        icon={electricityIcon}
        title={texts.electricityCard.title}
        value={texts.electricityCard.value}
      />
    )
    case IncidentCategoryOption.Gardering: return (
      <SmallInfoCard
        icon={gardeningIcon}
        title={texts.gardeningCard.title}
        value={texts.gardeningCard.value}
      />
    )
    case IncidentCategoryOption.Gas: return (
      <SmallInfoCard
        icon={gasIcon}
        title={texts.gasCard.title}
        value={texts.gasCard.value}
      />
    )
    case IncidentCategoryOption.Internet: return (
      <SmallInfoCard
        icon={internetIcon}
        title={texts.internetCard.title}
        value={texts.internetCard.value}
      />
    )
    case IncidentCategoryOption.MetalCarpentry: return (
      <SmallInfoCard
        icon={metalCarpentryIcon}
        title={texts.metalCarpentryCard.title}
        value={texts.metalCarpentryCard.value}
      />
    )
    case IncidentCategoryOption.Other: return (
      <SmallInfoCard
        icon={otherIcon}
        title={texts.otherCard.title}
        value={texts.otherCard.value}
      />
    )
    case IncidentCategoryOption.Water: return (
      <SmallInfoCard
        icon={waterIcon}
        title={texts.waterCard.title}
        value={texts.waterCard.value}
      />
    )
    case IncidentCategoryOption.WoodCarpentry: return (
      <SmallInfoCard
        icon={woodCarpentryIcon}
        title={texts.woodCarpentryCard.title}
        value={texts.woodCarpentryCard.value}
      />
    )
    case IncidentCategoryOption.Lock: return (
      <SmallInfoCard
        icon={lockIcon}
        title={texts.lockCard.title}
        value={texts.lockCard.value}
      />
    )
    default:
      return null
  }
}